<template>
  <div class="space-x-6">
    <button
      type="button"
      class="cursor-pointer"
      :aria-label="$t('app.previous')"
      @click="$emit('prev')"
    >
      <img
        :src="arrow"
        :alt="$t('app.previous')"
        class="rotate-180"
      />
    </button>
    <button
      type="button"
      :aria-label="$t('app.next')"
      class="cursor-pointer"
      @click="$emit('next')"
    >
      <img
        :src="arrow"
        :alt="$t('app.next')"
      />
    </button>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterCarouselButtons',

  data() {
    return {
      arrow: getAssetUrl('/images/arrows/straight-shortest-pink-arrow.svg'),
    };
  },
};
</script>
